import general from "./nl/general";

export  default {
    general,
}
